import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import InputCheckbox from "../InputCheckbox/index.js";
import styles from "@bookingcom/bui-core/css/Table.module.css";
var TableHead = function (props) {
    var headings = props.headings, checkboxName = props.checkboxName, rowsAmount = props.rowsAmount, value = props.value, onSelectAll = props.onSelectAll, hasCollapsibleRows = props.hasCollapsibleRows;
    var actionCellClassNames = classNames(styles.cell, styles["cell--head"], styles["cell--action"]);
    var isChecked = (value && rowsAmount === value.length) || false;
    var isIndeterminate = value && value.length > 0 && value.length < rowsAmount;
    return (React.createElement("thead", { className: styles.head },
        React.createElement("tr", { className: styles.row },
            hasCollapsibleRows && React.createElement("td", { className: actionCellClassNames }),
            checkboxName && (React.createElement("th", { className: actionCellClassNames },
                React.createElement(InputCheckbox, { name: "_check-all", checked: isChecked, indeterminate: isIndeterminate, onChange: onSelectAll }))),
            headings.map(function (heading, index) {
                var headingClassName = classNames(styles.cell, styles["cell--head"], heading.align && styles["cell--align-".concat(heading.align)], heading.className);
                return (React.createElement("th", { key: heading.key ||
                        heading.id ||
                        (typeof heading.content === "string" && heading.content) ||
                        index, className: headingClassName, colSpan: heading.colspan, style: { width: heading.width, minWidth: heading.width } }, heading.content));
            }))));
};
export default TableHead;
